import { createReducer, createActions } from 'reduxsauce';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    search: ["keyword"],
    fetch: ["result"],
    changeTag: ["args"],
    searchCatalog: ["args"],
    fetchCatalog: ["catalogResult"],
    clearSearch: [],
});

export const SearchTypes = Types;
export const INITIAL_STATE = {
    keyword: "",
    result: [],
    tag: "",
    catalogKeyword: "",
    catalogResult: [],
};


export const search = (state = INITIAL_STATE, { keyword }) => {
    return { ...state, keyword };
};

export const fetch = (state = INITIAL_STATE, { result }) => {
    return { ...state, result };
};

export const changeTag = (state = INITIAL_STATE, { args }) => {
    return { ...state, tag: args.tag, catalogKeyword: args.catalogKeyword };
};

export const searchCatalog = (state = INITIAL_STATE, { args }) => {
    return { ...state, tag: args.tag, catalogKeyword: args.catalogKeyword };
};

export const fetchCatalog = (state = INITIAL_STATE, { catalogResult }) => {
    return { ...state, catalogResult };
};

export const clearSearch = (state = INITIAL_STATE, {}) => {
    return {
        ...state, keyword: '', result: [], tag: '', catalogKeyword: '', catalogResult: [],
    };
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SEARCH]: search,
    [Types.FETCH]: fetch,
    [Types.CHANGE_TAG]: changeTag,
    [Types.SEARCH_CATALOG]: searchCatalog,
    [Types.FETCH_CATALOG]: fetchCatalog,
    [Types.CLEAR_SEARCH]: clearSearch,
});

export default Creators;
